export default defineNuxtPlugin<{ gtag: Gtag.Gtag }>({
  name: 'gtag',
  setup: () => ({
    provide: {
      gtag() {
        (window.gtag || (() => {}))(...arguments);
      },
    },
  }),
});
